<details-page-layout [title]="companyStore.selectedCompany()?.name || 'Company detail' " (back)="utils.navigateTo('/companies')">
   @if (companyStore.selectedCompany(); as company) {
    <company-form
      title="Update company"
      submitLabel="Save company"
      [busy]="companyStore.saving()"
      [readOnly]="!canUpdate()"
      [initialValue]="company"
      [canToggleActive]="(company.isActive && canDeactivate()) || (!company.isActive && canActivate())"
      [companyIsBusy]="(companyStore.activating() || companyStore.deactivating())"
      (deactivateAction)="toggleCompanyActive(company)"
      (submitted)="saveCompany($event)" />
    <company-detail-panels
      detailsTitle="Divisions"
      [companyId]="companyId"
      [canManage]="canUpdate()"
      [data]="companyStore.divisions()"
      (manageDetails)="manageDivision($event)" />
    <company-detail-panels
      detailsTitle="Job Titles"
      [companyId]="companyId"
      [canManage]="canUpdate()"
      [data]="companyStore.jobTitles()"
      (manageDetails)="manageJobTitle($event)" />
    <company-detail-panels
      detailsTitle="Organisational Levels"
      [companyId]="companyId"
      [canManage]="canUpdate()"
      [data]="companyStore.organisationalLevels()"
      (manageDetails)="manageOrganisationalLevel($event)" />
  } @else {
    <mat-card class="p-5">
      <p class="text-sm">Company data is loading or was not found.</p>
    </mat-card>
  }
</details-page-layout>